var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalThreat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1348.782 139.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M75.146,121.977H13.476V14.9h61.67V33.5H36.182V57.012H72.436v18.6H36.182v27.612H75.146Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.058,121.977H155.13l-24.9-40.5-24.9,40.5H81.009l35.522-55.224L83.279,14.9h25.049L131.4,53.423,154.031,14.9h24.463L144.876,68Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.843,121.977h-22.7V33.794H181.06V14.9h80.86v18.9H232.843Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.069,121.977H275.4V14.9h61.67V33.5H298.1V57.012h36.255v18.6H298.1v27.612h38.965Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.113,80.888v41.089h-22.7V14.9h31.2q21.825,0,32.3,7.948t10.474,24.132a28.413,28.413,0,0,1-5.2,16.809,34.413,34.413,0,0,1-14.722,11.536q24.169,36.108,31.494,46.655H416.76L391.2,80.888Zm0-18.457h7.324q10.767,0,15.894-3.588t5.127-11.28q0-7.617-5.237-10.84T386,33.5h-6.885Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.427,121.977H518.569L471.987,40.971h-.659q1.391,21.462,1.392,30.616v50.39H452.432V14.9h28.637l46.509,80.2h.513q-1.1-20.874-1.1-29.516V14.9h20.435Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.932,121.977l-7.764-25.488H590.13l-7.764,25.488H557.9L595.7,14.458h27.759L661.4,121.977ZM623.748,77.446Q612.981,42.8,611.626,38.262t-1.941-7.178q-2.417,9.377-13.842,46.362Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.871,121.977V14.9h22.706v88.33h43.431v18.75Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.885,121.977H808.18V33.794H779.1V14.9h80.859v18.9H830.885Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.186,121.977H938.554V75.762H896.147v46.215H873.442V14.9h22.705V56.865h42.407V14.9h22.632Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.918,80.888v41.089H985.213V14.9h31.2q21.825,0,32.3,7.948t10.474,24.132a28.413,28.413,0,0,1-5.2,16.809,34.413,34.413,0,0,1-14.722,11.536q24.169,36.108,31.494,46.655h-25.195L1020,80.888Zm0-18.457h7.325q10.765,0,15.893-3.588t5.127-11.28q0-7.617-5.237-10.84T1014.8,33.5h-6.885Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.907,121.977h-61.67V14.9h61.67V33.5h-38.965V57.012H1140.2v18.6h-36.255v27.612h38.965Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.8,121.977l-7.763-25.488h-39.038l-7.764,25.488h-24.463l37.793-107.519h27.759l37.939,107.519Zm-13.183-44.531q-10.767-34.644-12.122-39.184t-1.941-7.178q-2.416,9.377-13.843,46.362Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.045,121.977H1281.34V33.794h-29.077V14.9h80.859v18.9h-29.077Z",
    style: {
      fill: "#05b758"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalThreat);
export default __webpack_public_path__ + "static/media/External-Threat.fe726cba9c67b63da67e0bf01de3fb30.svg";
export { ForwardRef as ReactComponent };